module.exports = __webpack_public_path__ + "static/img/avatar_default.a0dfc9c3.png";